import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IParams {
  hiddenStatusUids: string[];
  moduleUid: string;
  processUid: string;
}

export const usePatchOrderProcessModuleQuery = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ hiddenStatusUids, moduleUid, processUid }: IParams) =>
      Api.orders.patchOrderProcessModel(processUid, moduleUid, {
        settings: {
          hidden_status_uids: hiddenStatusUids,
        },
      }),
    onSuccess: async () => {
      await client.invalidateQueries(['getProcess']);
    },
  });
};
